import { render, staticRenderFns } from "./RectShape.vue?vue&type=template&id=4fe0b076&scoped=true&"
import script from "./RectShape.vue?vue&type=script&lang=js&"
export * from "./RectShape.vue?vue&type=script&lang=js&"
import style0 from "./RectShape.vue?vue&type=style&index=0&id=4fe0b076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0b076",
  null
  
)

export default component.exports